export default __webpack_public_path__ + "static/media/ert_wheel_bg.19efad40.svg";